import { API } from '@/modules/api-service/api-service';
import type { Data, Core } from '@strapi/types';

const url = '/release-notes';

export const getReleaseNotes = async ({ documentId }: { documentId: Data.Entity<'api::release-note.release-note'>['documentId'] }) => {
	const { data: response } = await API().get<Core.Helpers.Controllers.GetResponseBody<'api::release-note.release-note', 'getReleaseNotes'>>(
		`${url}/${documentId}`,
	);

	return response;
};

export const checkIfUserViewedLastNoteApi = async (
	body: Core.Helpers.Controllers.GetRequestBody<'api::release-note.release-note', 'checkIfUserViewedLastNote'>,
) => {
	return await API().post<
		Core.Helpers.Controllers.GetResponseBody<'api::release-note.release-note', 'checkIfUserViewedLastNote'>,
		Core.Helpers.Controllers.GetRequestBody<'api::release-note.release-note', 'checkIfUserViewedLastNote'>
	>(`${url}/check-last-is-viewed`, body);
};

export const setUserViewedNoteApi = async (
	body: Core.Helpers.Controllers.GetRequestBody<'api::release-note.release-note', 'setUserViewedNote'>,
) => {
	return await API().post(`${url}/set-user-viewed`, body);
};
